import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import './Breakline.css';

class Breakline extends React.Component<Props> {
  render() {
    return (
      <ResponsiveStyle>
        <Box
          sx={{
            borderTop: 5,
            borderBottom: 5,
            borderColor: 'grey.500',
            mx: 'auto',
            mt: 5,
            mb: 2,
            p: 0,
          }}
          className='breakline-box'
        >
          <img
            className='breakline-image'
            src={this.props.img}
            alt={this.props.description}
          />
          <Box className='breakline-content' sx={{p: '10px'}}>
            <div className='breakline-title'>
              <Typography align='center' variant='h4' component='div'>
                {this.props.title}
              </Typography>
              <Typography align='center' component='div' sx={{mt: '5px'}}>
                {this.props.range}
              </Typography>
            </div>
            <div className='breakline-textarea'>
              <Typography align='center' component='div' sx={{p: '10px'}}>
                {this.props.description}
              </Typography>
            </div>
          </Box>
        </Box>
      </ResponsiveStyle>
    );
  }
}

const ResponsiveStyle = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    '& .MuiBox-root': {
      width: 800,
    },
  },
}));


type Props = {
  title: string,
  range: string,
  description: string,
  img: string;
}

export default Breakline;
